import "./ProgressStepper.css";

function ProgressStepper({ step }) {
  return (
    <div className="stepper">

      <div className={`step ${step >= 1 ? "active" : ""}`}>
        <div className="circle">1</div>
        <span>Details</span>
      </div>

      <div className={`line ${step >= 2 ? "active" : ""}`}></div>

      <div className={`step ${step >= 2 ? "active" : ""}`}>
        <div className="circle">2</div>
        <span>OTP</span>
      </div>

      <div className={`line ${step >= 3 ? "active" : ""}`}></div>

      <div className={`step ${step >= 3 ? "active" : ""}`}>
        <div className="circle">3</div>
        <span>Password</span>
      </div>

    </div>
  );
}

export default ProgressStepper;